"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var react_tracking_1 = require("react-tracking");
var lodash_1 = require("lodash");
var elog = require("../../elog");
var bind_1 = require("../../bind");
var sanitized_render_1 = require("../../components/sanitized_render");
var csp_row_1 = require("../../components/csp_row");
var tiles_1 = require("../../components/tiles");
var csp_feature_list_item_1 = require("./csp_feature_list_item");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
var I18n = require("i18n-js");
var rql_1 = require("../../rql");
exports.FEATURE_TYPES = [
    'cspRow',
    'squareGrid',
    'orderedList'
];
var COMPONENT_NAME = 'CspCollection';
var CspCollection = /** @class */ (function (_super) {
    tslib_1.__extends(CspCollection, _super);
    function CspCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CspCollection.prototype.componentDidMount = function () {
        if (!this.props.data.loading && this.csps().length) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.csps().map(function (csp) { return csp.id; })
            });
        }
    };
    CspCollection.prototype.componentDidUpdate = function (oldProps) {
        if (!this.props.data.loading && this.csps().length && !lodash_1.isEqual(this.props.data, oldProps.data)) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.csps().map(function (csp) { return csp.id; })
            });
        }
    };
    CspCollection.prototype.action = function () {
        if (!this.props.ctaTargetHref) {
            return;
        }
        return (React.createElement(core_link_1.default, { interactionType: tracker_1.CTA, to: this.props.ctaTargetHref }, this.props.ctaText ? this.props.ctaText : I18n.t('cms.comparisonShoppingPages.seeMore')));
    };
    CspCollection.prototype.csps = function () {
        return lodash_1.get(this.props, 'data.cspSearch.csps', []);
    };
    CspCollection.prototype.displayAs = function (style) {
        return this.props.displayAs === style;
    };
    CspCollection.prototype.renderTitle = function () {
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    CspCollection.prototype.renderOrderedListItem = function (csp, idx) {
        return (React.createElement(csp_feature_list_item_1.default, { csp: csp, key: idx, listPosition: idx + 1, position: idx, useCspSummary: this.props.useCspSummary }));
    };
    CspCollection.prototype.renderOrderedList = function () {
        return (React.createElement("div", { className: "csp-feature-list" },
            React.createElement("h2", { className: "csp-feature-list__heading" }, this.renderTitle()),
            React.createElement(tiles_1.default, { oneWide: true, loading: this.props.data.loading, placeholder: React.createElement(csp_feature_list_item_1.default, null) }, this.csps().map(this.renderOrderedListItem))));
    };
    CspCollection.prototype.render = function () {
        // legacy support for boolean flag
        var displayAsGrid = this.displayAs('squareGrid') || this.props.displayAsGrid;
        try {
            if (this.displayAs('orderedList')) {
                return this.renderOrderedList();
            }
            return (React.createElement(csp_row_1.default, { title: this.renderTitle(), subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, id: this.props.jumplinkSlug, csps: this.csps(), expectedCount: this.props.maxCount, action: this.action(), loading: this.props.data.loading, conditionFilter: this.props.condition, displayAsGrid: displayAsGrid }));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CspCollection.defaultProps = {
        sort: rql_1.reverb_search_CSPSearchRequest_Sort.TRENDING_DESC,
        maxCount: 12,
    };
    tslib_1.__decorate([
        bind_1.default
    ], CspCollection.prototype, "renderOrderedListItem", null);
    CspCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.CSP_TYPE,
                context: {
                    title: props.title,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                    collectionId: props.collectionId,
                    query: props.query,
                    make: props.make,
                    categoryId: props.categoryId,
                    condition: props.condition,
                    maxCount: props.maxCount,
                    sort: props.sort,
                }
            };
        })
    ], CspCollection);
    return CspCollection;
}(React.Component));
exports.CspCollection = CspCollection;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_Cms_CspCollection(\n      $curatedSetId: String\n      $fullTextQuery: String\n      $brandNames: [String]\n      $condition: String\n      $limit: Int\n      $categoryUuids: [String]\n      $sort: reverb_search_CSPSearchRequest_Sort\n    )\n    {\n      cspSearch(input: {\n        curatedSetId: $curatedSetId\n        fullTextQuery: $fullTextQuery\n        brandNames: $brandNames\n        condition: $condition\n        limit: $limit\n        withInventory: true\n        sort: $sort\n        categoryUuids: $categoryUuids\n      }) {\n        csps {\n          ...CSPCard\n          metaDescription\n          summary\n          reviews {\n            total\n            avgRating\n          }\n          brand {\n            name\n          }\n        }\n      }\n    }\n    ", "\n  "], ["\n    query Commons_Cms_CspCollection(\n      $curatedSetId: String\n      $fullTextQuery: String\n      $brandNames: [String]\n      $condition: String\n      $limit: Int\n      $categoryUuids: [String]\n      $sort: reverb_search_CSPSearchRequest_Sort\n    )\n    {\n      cspSearch(input: {\n        curatedSetId: $curatedSetId\n        fullTextQuery: $fullTextQuery\n        brandNames: $brandNames\n        condition: $condition\n        limit: $limit\n        withInventory: true\n        sort: $sort\n        categoryUuids: $categoryUuids\n      }) {\n        csps {\n          ...CSPCard\n          metaDescription\n          summary\n          reviews {\n            total\n            avgRating\n          }\n          brand {\n            name\n          }\n        }\n      }\n    }\n    ", "\n  "])), csp_row_1.CSPCardFragment), {
    options: function (ownProps) {
        return {
            ssr: ownProps.ssr,
            variables: {
                curatedSetId: ownProps.collectionId,
                fullTextQuery: ownProps.query,
                brandNames: ownProps.make,
                condition: ownProps.condition,
                limit: ownProps.maxCount || 12,
                categoryUuids: ownProps.categoryId ? [ownProps.categoryId] : [],
                sort: ownProps.sort || rql_1.reverb_search_CSPSearchRequest_Sort.TRENDING_DESC,
            }
        };
    },
});
exports.default = connect(CspCollection);
var templateObject_1;
//# sourceMappingURL=csp_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/csp_collection.js
// module id = Sh5L
// module chunks = 0 2 6 8 20